import { HttpResponse } from '@angular/common/http';
import { Component, inject, input } from '@angular/core';
import {
	ApiPaginatedResponse,
	ApiRequestOrdering,
	ApiRequestPagination,
	DataExportFormatEnum,
	VehicleRoadTaxSearchDto,
	VehicleRoadTaxesFilters,
	ModulesEnum,
	VehicleRoadTaxesStatsDto,
} from '@splitsecondconnect/ultramarine-shared';
import { Observable } from 'rxjs';

import { FiltersConfig } from '../../../../shared/models/filters-config';
import { ListStrategy } from '../../../../shared/models/list-strategy';
import { SelectItem } from '../../../../shared/models/select-item.type';
import { VehicleRoadTaxesListItemMenuComponent } from '../components/vehicle-road-taxes-list-item-menu/vehicle-road-taxes-list-item-menu.component';
import { mapDtoToModelVehicleRoadTaxes } from '../mappers/search-dto-to-model.mapper';
import { VehicleRoadTaxesSectionItemComponent } from '../sections/vehicle-road-taxes-section-item/vehicle-road-taxes-section-item.component';
import { VehicleRoadTaxesService } from '../vehicle-road-taxes.service';

import { getVehicleRoadTaxFilters } from './vehicle-road-tax-filters.config';

@Component({
	selector: 'app-vehicle-road-tax-list-selected-item',
	imports: [VehicleRoadTaxesSectionItemComponent],
	host: {
		class: 'w-full',
	},
	template: `
		<app-vehicle-road-taxes-section-item [plain]="plain()" [item]="item()" />
	`,
})
class VehicleRoadTaxListItemComponent {
	item = input<SelectItem<VehicleRoadTaxSearchDto>>();
	plain = input<boolean>();
	moduleEnum = ModulesEnum;
}

export class VehicleRoadTaxListStrategy implements ListStrategy<
	VehicleRoadTaxesFilters,
	VehicleRoadTaxSearchDto,
	VehicleRoadTaxesStatsDto
> {
	module = ModulesEnum.VEHICLE_ROAD_TAXES;
	#service = inject(VehicleRoadTaxesService);
	component: any = VehicleRoadTaxListItemComponent;
	componentMenu: any = VehicleRoadTaxesListItemMenuComponent;
	ordering: ApiRequestOrdering = {
		columnName: `vehicle_road_tax.id`,
		direction: 'DESC',
	};

	mapDtoToModel(
		vehicleRoadTaxes: VehicleRoadTaxSearchDto[],
	): SelectItem<VehicleRoadTaxSearchDto>[] {
		return mapDtoToModelVehicleRoadTaxes(vehicleRoadTaxes);
	}

	getStats() {
		return this.#service.getStats();
	}

	getSearchResults(
		searchQuery: string,
		searchQueryIds: number[],
		pageSize: number,
		searchFilters: VehicleRoadTaxesFilters,
		page: number,
		ordering: ApiRequestOrdering,
	): Observable<ApiPaginatedResponse<VehicleRoadTaxSearchDto[]>> {
		return this.#service.getSearchResults(
			searchQuery,
			searchQueryIds,
			pageSize,
			searchFilters,
			page,
			ordering,
		);
	}

	exportList(
		format: DataExportFormatEnum,
		options: object,
		searchQueryIds: number[],
		searchFilters?: VehicleRoadTaxesFilters,
		searchQuery?: string,
		pagination?: ApiRequestPagination,
		ordering?: ApiRequestOrdering,
	): Observable<HttpResponse<Blob>> {
		return this.#service.exportList(
			searchFilters,
			searchQuery,
			searchQueryIds,
			pagination,
			ordering,
			format,
			options,
		);
	}

	clearFilters() {
		this.#service.resetVehicleRoadTaxesFilters();
	}

	getFiltersConfig(): FiltersConfig[] {
		return getVehicleRoadTaxFilters();
	}

	filtersObject: VehicleRoadTaxesFilters = this.#service.filtersObject;

	filterSubjects: any = this.#service.vehicleRoadTaxesFilters;
}
